'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant"];
var _CloseSmall;
import AlertTriangle from '@crehana/compass.icons.fill/AlertTriangle';
import CheckmarkCircle from '@crehana/compass.icons.fill/CheckmarkCircle';
import CloseCircle from '@crehana/compass.icons.fill/CloseCircle';
import Info from '@crehana/compass.icons.fill/Info';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import { cva } from 'class-variance-authority';
import { toast } from 'sonner';
import { cn } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var toastVariants = /*#__PURE__*/cva('', {
  variants: {
    variant: {
      info: 'tw-text-info-600 dark:tw-text-info-300 data-[border]:tw-bg-info-600 dark:data-[border]:tw-bg-info-300',
      success: 'tw-text-success-500 dark:tw-text-success-400 data-[border]:tw-bg-success-500 dark:data-[border]:tw-bg-success-400',
      warning: 'tw-text-on-hold-500 dark:tw-text-on-hold-300 data-[border]:tw-bg-on-hold-500 dark:data-[border]:tw-bg-on-hold-300',
      error: 'tw-text-alert-500 darkLtw-text-alert-300 data-[border]:tw-bg-alert-500 dark:data-[border]:tw-bg-alert-300'
    }
  },
  defaultVariants: {
    variant: 'success'
  }
});
export var ToastContent = function ToastContent(_ref) {
  var id = _ref.id,
    title = _ref.title,
    variant = _ref.variant,
    opts = _ref.opts;
  var showDescription = (opts === null || opts === void 0 ? void 0 : opts.description) || (opts === null || opts === void 0 ? void 0 : opts.textLink);
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-w-full sm:tw-max-w-[380px] tw-min-w-[328px] tw-rounded tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-03 tw-shadow-03 dark:tw-shadow-none tw-h-full tw-overflow-hidden",
    children: [/*#__PURE__*/_jsx("div", {
      "data-border": true,
      className: cn('tw-w-0.4 tw-h-full tw-rounded-l tw-shrink-0 tw-absolute', toastVariants({
        variant: variant
      }))
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-px-1.6 tw-py-1.2 tw-w-full tw-gap-0.8",
      children: [/*#__PURE__*/_jsx("div", {
        className: "tw-shrink-0",
        children: /*#__PURE__*/_jsx(ToastIcon, {
          variant: variant,
          size: 20,
          className: toastVariants({
            variant: variant
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-space-y-0.4",
        children: [/*#__PURE__*/_jsx("h3", {
          className: cn(toastVariants({
            variant: variant
          }), 'tw-font-subtitle5 dark:tw-text-neutral-light-100 tw-line-clamp-3', opts === null || opts === void 0 ? void 0 : opts.titleClassName),
          children: title
        }), showDescription && /*#__PURE__*/_jsxs("p", {
          className: "tw-font-body5 tw-line-clamp-3 tw-text-neutral-light-700 dark:tw-text-neutral-light-100",
          children: [opts.description, opts.textLink && /*#__PURE__*/_jsx("span", {
            className: cn(toastVariants({
              variant: variant
            }), 'tw-ml-0.4'),
            children: /*#__PURE__*/_jsx("a", {
              className: "tw-font-caption tw-underline",
              href: opts.textLink.url,
              target: "_blank",
              rel: "noreferrer",
              children: opts.textLink.text
            })
          })]
        })]
      }), !(opts !== null && opts !== void 0 && opts.hideCloseButton) && /*#__PURE__*/_jsx("button", {
        className: "tw-mb-auto tw-ml-auto",
        type: "button",
        onClick: function onClick() {
          return toast.dismiss(id);
        },
        children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
          size: 20,
          className: "tw-text-neutral-light-700 dark:tw-text-neutral-dark-500"
        }))
      })]
    })]
  });
};
function ToastIcon(_ref2) {
  var variant = _ref2.variant,
    iconProps = _objectWithoutProperties(_ref2, _excluded);
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (variant === 'info') return /*#__PURE__*/_jsx(Info, _objectSpread({}, iconProps));
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (variant === 'success') return /*#__PURE__*/_jsx(CheckmarkCircle, _objectSpread({}, iconProps));
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (variant === 'warning') return /*#__PURE__*/_jsx(AlertTriangle, _objectSpread({}, iconProps));
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (variant === 'error') return /*#__PURE__*/_jsx(CloseCircle, _objectSpread({}, iconProps));
  return null;
}